module.exports = __webpack_public_path__ + "static/media/East Tower 2.5c7aab53.png";